import {
  VOICE_OVER_PRICES as VOICE_OVER_PRICES_V1,
  VOICE_OVER_PRICES_V2,
  VOICE_OVER_PRICES_V3 } from
'@shootsta/common-domain-data';

const getPriceVersion = (version) => {
  switch (version) {
    case 'V1':
      return VOICE_OVER_PRICES_V1;
    case 'V2':
      return VOICE_OVER_PRICES_V2;
    case 'V3':
      return VOICE_OVER_PRICES_V3;
    default:
      return VOICE_OVER_PRICES_V1;
  }
};

export { getPriceVersion };